<template>
<ContentWrapper>
    <div class="content-heading">
      <div>서류 인증 관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          회원관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/mem/certifiedList">서류 인증 관리</a>
        </li>
      </ol>
    </div>
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="조회" :data="data" :ranges="dateRanges" @search="search" @reset="reset" />
          <!-- 분류 -->
          <div class="form-group no-margin row" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">인증상태</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="certifyOptions" v-model="data.params.fileCertifyStatus" @change="search()" class="custom-select custom-select-sm"></b-form-select>
            </div>
          </div>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset" style="width:100%"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->


    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">서류인증 현황 : {{data.month}}월 승인 
        <span class="text-blue">{{data.monthlyCount}}</span>건 (총 <span class="text-blue">{{data.totalCount}}</span>건)</span>
        <br/><br/>
        <span class="text-bold h4">목록</span>
        <div class="card-tool float-right" >
          <!-- <b-btn class="btn btn-xs btn-outline-danger mr-2" variant="danger-primary" @click="delFile()" :disabled="!data.enabledDelete">선택 삭제</b-btn> -->
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" @click="acceptOrRejectFile(true)" :disabled="!data.enabledAccept">인증 하기</b-btn>
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" @click="acceptOrRejectFile(false)" :disabled="!data.enabledReject">인증 거절</b-btn>
        </div>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td style=""><input type="checkbox" v-model="data.selectAllTeacher" /></td>
              <td style="text-align:center">No</td>
              <td style="text-align:center" @click="localSort.sort('loginId')">ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('name')">이름<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('schlNm')">학교<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('subjectName')">과목<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('fileRegDt')">신청일<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('fileCertifyStatus')">인증상태<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center">서류첨부</td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
            <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index"> <!--  @click.prevent="detail(item.seq);" -->
              <td style=""><input type="checkbox" v-model="data.selectedTeachers" :value="item.loginId" /></td>
              <td class="align-middle text-center" @click="goDetail(item.loginId)">{{data.params.limit*(data.params.page-1) + index+1}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId)">{{item.maskedLoginId}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId)">{{item.name}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId)">{{item.schlNm}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId)">{{item.subjectName}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId)">{{item.fileRegDt}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId)">{{item.fileCertifyStatusName}}</td>
              <td class="align-middle text-center" >
                <span v-if="!item.file">파일 없음</span>
                <span v-else-if="item.file === 'Deleted'">파일 삭제됨</span>
                <span v-else-if="item.file.startsWith('http')">
                  <!-- <a :href="item.file" target="_blank">⬇️</a>&emsp;&emsp; -->
                  <a href="#" @click.prevent="openFileInNewTab(item.file)"><em class="fa fa-search"></em></a>&emsp;&emsp;
                  <a href="javascript:void(0);" @click="delFile(item.loginId)">❌</a>
                </span>
                <span v-else>{{item.file}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<style scoped>
  .text-blue {
    color: #23b7e5
  }
</style>

<script>
import Vue from 'vue';
import store from "@/store/index";
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api';
import {dataObject, userTypeCd, getUserTypeName, schoolDivCd, getSchoolDivName} from "@/utils/Constants";
import {getUserTeacherList, getUserTeacherDetail, setUserTeacherCertify, setUserTeacherReject, deleteUserTeacherFile} from "@/api/mem/MemberAPI";
import {getUserJoinYn, setYcloudUserTeacherCertify, setYcloudUserTeacherReject, deleteYcloudUserTeacherFile} from "@/api/mem/extMemberAPI";
import {setBooksamUserTeacherCertify, setBooksamUserTeacherReject, deleteBooksamUserTeacherFile} from "@/api/mem/extMemberAPI";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import moment from 'moment';
import axios from "axios";

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {SchDateRange, SchText, ShowCounter, Pagenation, Loading},
    setup(props, {root}) {

      const modalLoading = ref(false);

      const _dataObject = _.cloneDeep(dataObject);
      _dataObject.params.fileCertifyStatus = "";
      _dataObject.selectedTeachers = [];
      _dataObject.selectAllTeacher = computed({
        get() {
          return data.list.length ? data.selectedTeachers.length == data.list.length : false;
        },
        set(newValue) {
          let selected = [];
          if (newValue) {
            data.list.forEach(item => {
              selected.push(item.loginId);
            });
          }
          data.selectedTeachers = selected;
        }
      });

      // disable button
      const enabledButton = () => {
        if (data.selectedTeachers.length == 0) {
          return false;
        }
        return true;
      }
      const enabledDelete = () => {
        let result = enabledButton();
        if (result) {
          const selectedTeachers = data.list.filter(item => data.selectedTeachers.includes(item.loginId));
          return selectedTeachers.some(item => item.file && item.file.startsWith('http'));
        }
        return result;
      }
      const enabledAccept = () => {
        let result = enabledButton();
        if (result) {
          const selectedTeachers = data.list.filter(item => data.selectedTeachers.includes(item.loginId));
          return selectedTeachers.some(item => item.fileCertifyStatus == 'U');
        }
        return result;
      }
      const enabledReject = () => {
        let result = enabledButton();
        if (result) {
          const selectedTeachers = data.list.filter(item => data.selectedTeachers.includes(item.loginId));
          return selectedTeachers.some(item => item.fileCertifyStatus == 'U');
        }
        return result;
      }
      _dataObject.enabledDelete = computed(enabledDelete);
      _dataObject.enabledAccept = computed(enabledAccept);
      _dataObject.enabledReject = computed(enabledReject);
      const data = reactive(_dataObject);

      const dateRanges = [
        {value:{int:0, type:'d'}, text:'오늘'},
        {value:{int:15, type:'d'}, text:'15일'},
        {value:{int:1, type:'M'}, text:'1개월'}
      ]
      const certifyOptions = [
        {value:"", text:"전체"},
        {value:"U", text:"인증대기"},
        {value:"R", text:"인증거절"},
      ];
      const schOptions = [
        {value: 'name', text: '이름'},
        {value: 'loginId', text: 'ID'},
        {value: 'schlNm', text: '학교명'}];
      data.schOptions = schOptions;
      data.month = moment().format('MM');
      data.monthlyCount = 0;
      data.totalCount = 0;

      const loadData = async () => {
        if (store.state.params.name == 'certifiedList') {
          data.params = store.state.params.data;
          store.commit('setParams', {name:'', data:undefined});
        }
        let result = await getUserTeacherList(data.params);
        data.list = result.data.userTeacherList;
        root.$_localSort.set(data.list);
        data.row = {};
        data.params.mode = "list";

        data.list.forEach(item => {
          if (item.fileCertifyStatus) {
            const certifyObj = certifyOptions.find(certify => certify.value === item.fileCertifyStatus);
            item.fileCertifyStatusName = certifyObj ? certifyObj.text : '';
          } else {
            item.fileCertifyStatusName = '';
          }
        })
        data.count = result.count;
        data.monthlyCount = result.data.monthlyCount || 0;
        data.totalCount = result.data.totalCount || 0;
      };

      onMounted(loadData);

      return {
        modalLoading,
        dataObject,
        _dataObject,
        data,
        dateRanges,
        certifyOptions,
        userTypeCd,
        schoolDivCd,
        loadData,
        ...methods(),
        dataAction: new TableActionClass(data),
        localSort:root.$_localSort,
      }
    }
}

function methods() {

  // 목록
  async function search() {
    this.loadData();
  }

  // 상세
  async function goDetail(loginId){
    this.$store.commit('setParams', {name:'certifiedList', data:this.data.params});
    this.$router.push({name:'certifiedDetail', params:{loginId:loginId}});
  }

  async function reset() {
    this.data.params.mode="list";
  }

  function list() {
    this.search();
  }

  /**
   * 서류 탭으로 보기.
   */
  async function openFileInNewTab(fileUrl) {
    if (!fileUrl) {
      alert("파일 주소가 없습니다.");
      return;
    }

    try {
      const response = await axios.get(fileUrl, {
        responseType: 'blob',
      });

      const blob = response.data;
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');

      setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
    } catch (error) {
      console.log("파일을 여는 중 오류가 발생했습니다:", error);
      alert("파일을 열 수 없습니다.");
    }
  }

  /**
   * 서류 삭제
   */
  async function delFile(loginId) {
    const confirmStr = '선택한 서류를 삭제하시겠습니까?';
    if (!confirm(confirmStr)) {
      return;
    }

    console.log(`delete File of ${loginId}`);
    let filterSelectedList = loginId ? [{"loginId":loginId}]
      : this.data.list.filter(item => this.data.selectedTeachers.includes(item.loginId));
    console.log('filtered List', filterSelectedList);
    if (filterSelectedList.length == 0) {
      alert('삭제할 사용자가 없습니다.');
      return;
    }
    
    try {
      const result = await deleteUserTeacherFile(filterSelectedList);
      console.log(result);
      if (result.data) {
        const loginIdList = [];
        filterSelectedList.forEach(sel => loginIdList.push({"userId":sel.loginId}))
        let result = await deleteYcloudUserTeacherFile(loginIdList);
        console.log('deleteYcloudUserTeacherFile result:', result);

        result = await deleteBooksamUserTeacherFile(loginIdList);
        console.log('deleteBooksamUserTeacherFile result:', result);

        alert('서류를 삭제하였습니다.');
        if (this.data.params.mode == "list") {
          this.data.selectedTeachers = [];
          this.search();
        } else {
          this.detail(loginId);
        }
      } else if (result.message) {
        alert(result.message);
      } else {
        alert('결과값이 없습니다.');
      }
    } catch (err) {
      alert('오류가 발생했습니다.');
    }
  }

  /**
   * 서류 인증 수락/거절
   */
  async function acceptOrRejectFile(accept, loginId) {
    const confirmStr = accept ? '선택한 서류를 인증하시겠습니까?' : '선택한 서류를 인증거절하시겠습니까?\n인증거절할 경우 서류도 같이 삭제됩니다.';
    if (!confirm(confirmStr)) {
      return;
    }

    const statusStr = accept ? 'A' : 'R';
    let filterSelectedList = loginId ? [{"loginId":loginId}] : undefined;

    if (!filterSelectedList) {
      filterSelectedList = this.data.list.filter(item => item.fileCertifyStatus != statusStr)
        .filter(item => this.data.selectedTeachers.includes(item.loginId));
      if (filterSelectedList.length == 0) {
        alert(accept ? '인증할 사용자가 없습니다.' : '인증거절할 사용자가 없습니다.');
        return;
      }
    }

    try {
      console.log('filtered List', filterSelectedList);
      const result = accept ? await setUserTeacherCertify(filterSelectedList) : 
        await setUserTeacherReject(filterSelectedList);
      if (result.data) {
        const loginIdList = [];
        filterSelectedList.forEach(sel => loginIdList.push({"userId":sel.loginId}))
        let result = accept ? await setYcloudUserTeacherCertify(loginIdList) : 
          await setYcloudUserTeacherReject(loginIdList);
        console.log(accept ? 'setYcloudUserTeacherCertify' : 'setYcloudUserTeacherReject', 'result:', result);

        result = accept ? await setBooksamUserTeacherCertify(loginIdList) : 
          await setBooksamUserTeacherReject(loginIdList);
        console.log(accept ? 'setBooksamUserTeacherCertify' : 'setBooksamUserTeacherReject', 'result:', result);

        alert(accept ? "서류인증이 되었습니다." : "서류 인증거절 되었습니다.");
        if (this.data.params.mode == "list") {
          this.data.selectedTeachers = [];
          this.search();
        } else {
          this.detail(loginId);
        }
      } else if (result.message) {
        alert(result.message);
      } else {
        alert('결과값이 없습니다.');
      }
    } catch (err) {
      alert(`오류가 발생했습니다.`);
    }
    
  }

  return {
    search,
    goDetail,
    list,
    reset,
    openFileInNewTab,
    delFile,
    acceptOrRejectFile,
  }
}
</script>